import React from 'react'

const RemoteStart = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M234.3 480.241c-48.137 0-87.3-37.686-87.3-84.007V273.647c0-32.525 27.439-58.986 61.166-58.986h102.37c32.389 0 58.739 25.419 58.739 56.663v124.91c0 46.321-39.162 84.007-87.3 84.007H234.3z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M280.222 287.674c-.354 0-.688.335-.688.688v42.252c0 .354.335.689.688.689h39.174c.354 0 .689-.335.689-.689v-42.252c0-.354-.335-.688-.689-.688h-39.174zM195.769 287.674c-.354 0-.689.335-.689.688v42.252c0 .354.335.689.689.689h39.173c.354 0 .689-.335.689-.689v-42.252c0-.354-.335-.688-.689-.688h-39.173zM329.598 133.598c-47.608-18.743-99.465-17.113-146 4.591-8.647 4.027-12.673 14.969-8.989 24.435 3.609 9.45 13.663 13.872 22.31 9.845 38.627-18.004 81.652-19.357 121.164-3.802 8.847 3.477 18.587-1.547 21.767-11.229 1.776-5.409 1.125-11.127-1.334-15.728-1.942-3.635-5.016-6.576-8.918-8.112zM374.507 65.571c-1.759-3.29-4.447-6.014-7.886-7.657-70.872-33.775-151.279-31.694-220.609 5.704-8.426 4.55-11.891 15.712-7.74 24.952 4.299 9.229 14.35 13.031 22.782 8.477 60.328-32.543 130.308-34.357 191.995-4.96 8.613 4.102 18.634-.217 22.387-9.655 2.252-5.671 1.723-11.9-.929-16.861z"
    />
  </svg>
)
export default RemoteStart
